import { StepGraderType } from '../../../../constants/grading.ts';

import { UserSayBaseStateChangeHandlerUtil } from './user-say-base.handler.ts';

/**
 * Specialized handler for UserSayLetterName step type
 * Handles pronunciation of letter names (as opposed to letter sounds)
 */
export class UserSayLetterNameStateChangeHandlerUtil extends UserSayBaseStateChangeHandlerUtil {
  private static _instance: UserSayLetterNameStateChangeHandlerUtil;

  static get instance(): UserSayLetterNameStateChangeHandlerUtil {
    if (!UserSayLetterNameStateChangeHandlerUtil._instance) {
      UserSayLetterNameStateChangeHandlerUtil._instance = new UserSayLetterNameStateChangeHandlerUtil();
    }
    return UserSayLetterNameStateChangeHandlerUtil._instance;
  }

  protected getHandlerName(): string {
    return 'UserSayLetterName';
  }

  protected getGraderType(): StepGraderType {
    return StepGraderType.LETTER_NAME;
  }
}

export const getUserSayLetterNameStateChangeHandlerUtil = (): UserSayLetterNameStateChangeHandlerUtil =>
  UserSayLetterNameStateChangeHandlerUtil.instance;
